import * as yup from "yup";
import { ShipmentMessageType } from "../models/Shipment";

const message = "Campo Obrigatorio";

export const shipmentSchema = yup.object({
  id: yup
    .string()
    .notRequired()
    .nullable(),
  contact: yup
    .object({
      id: yup
        .string()
        .nonNullable()
        .required( message ),
    }),
  title: yup
    .string()
    .required( message ),
  shipmentMessageType: yup
    .string()
    .oneOf( Object.values( ShipmentMessageType )),
  content: yup
    .string()
    .required( message ),
  url: yup
    .string()
    .notRequired()
    .nullable(),
  file: yup
    .mixed<File>()
    .nullable()
    .when(["shipmentMessageType", "url"], {
      is: (type: ShipmentMessageType, url?: string | null) =>
        type !== ShipmentMessageType.TEXT &&
        !url,
      then: (schema) =>
        schema.required("Arquivo e obrigatorio"),
      otherwise: (schema) =>
        schema.notRequired().nullable(),
    }),
  sendDate: yup
    .string()
    .nonNullable()
    .required( message ),
  sendTime: yup
    .string()
    .notRequired()
    .nullable(),
});

export type ShipmentForm = yup.InferType<typeof shipmentSchema>;
